"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));

var _isString2 = _interopRequireDefault(require("lodash/isString"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

require("core-js/modules/es6.array.slice.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactComponents = require("@ucloud-fe/react-components");

var _excluded = ["timestamp", "unit", "showTime"];

var _this = void 0;

/**
 * DateTime
 * @description 展示格式化的日期时间，格式为 yyyy-mm-dd hh:mm:ss
 */
var DateTime = function DateTime(_ref) {
  var _this2 = this;

  (0, _newArrowCheck2["default"])(this, _this);
  var timestamp = _ref.timestamp,
      unit = _ref.unit,
      showTime = _ref.showTime,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var paddingWithZero = function paddingWithZero(str) {
    (0, _newArrowCheck2["default"])(this, _this2);
    return ("0" + str).slice(-2);
  }.bind(this);

  var getTs = function getTs(_timestamp, _unit) {
    (0, _newArrowCheck2["default"])(this, _this2);
    var ts = (0, _isString2["default"])(_timestamp) ? (0, _parseInt2["default"])(_timestamp) : _timestamp;

    if (_unit === "s") {
      return ts * 1000;
    }

    return ts;
  }.bind(this);

  var date = new Date(getTs(timestamp, unit));

  var getDate = function getDate() {
    (0, _newArrowCheck2["default"])(this, _this2);
    return "".concat(date.getFullYear(), "-").concat(paddingWithZero(date.getMonth() + 1), "-").concat(paddingWithZero(date.getDate()));
  }.bind(this);

  var getTime = function getTime() {
    (0, _newArrowCheck2["default"])(this, _this2);
    return "".concat(paddingWithZero(date.getHours()), ":").concat(paddingWithZero(date.getMinutes()), ":").concat(paddingWithZero(date.getSeconds()));
  }.bind(this);

  var fullDate = "".concat(getDate(), " ").concat(getTime());
  return showTime ? /*#__PURE__*/_react["default"].createElement("span", others, fullDate) : /*#__PURE__*/_react["default"].createElement(_reactComponents.Tooltip, {
    popup: fullDate,
    defaultVisible: false
  }, /*#__PURE__*/_react["default"].createElement("span", others, getDate()));
}.bind(void 0);

DateTime.propTypes = {
  /**
   * 时间戳（毫秒）
   */
  timestamp: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired,

  /**
   * 单位，默认为毫秒
   */
  unit: _propTypes["default"].oneOf(["ms", "s"]),

  /**
   * 是否展示时间部分
   */
  showTime: _propTypes["default"].bool,

  /** @ignore */
  className: _propTypes["default"].string
};
DateTime.defaultProps = {
  unit: "ms",
  showTime: false
};
var _default = DateTime;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/DateTime/DateTime.js
// module id = 2100
// module chunks = 6 7 17 18